import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Box, Typography, IconButton, Button, Autocomplete, ListItemText, MenuItem, TextField, Tooltip, Popper } from '@mui/material';
import { AddBox } from '@mui/icons-material';
import Checkbox from '@mui/material/Checkbox';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { MoneyFormatv2, MoneyFormatv3, NewMoneyFormatv2 } from '../../../library/MoneyFormat';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import { grey } from '@mui/material/colors';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import AddAccountModal from '../Modals/AddAccountModal';
import AddHSNModal from '../Modals/AddHSNModal';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import ToolTipComponent from '../Components/ToolTipComponent';
import { useTaxabilityOptions } from '../Components/UseTaxabilityOptions';
import UseLedgerAccount from '../Components/UseLedgerAccount';
import UseHSNMaster from '../Components/UseHSNMaster';
import { API, graphqlOperation } from 'aws-amplify';
import { getLedgerGSTData } from '../../../graphql';
import { useHandleTaxabilityChange } from '../Components/useHandleTaxabilityChange';
import { MoneyTextField } from '../../../components';
const useStyles = makeStyles((theme) => ({
  autocomplete: {
    '& .MuiAutocomplete-popper': {
      minWidth: 1000,
    },
  },
}));
function NewNonItemTable({
  nonItemWiseAccordan,
  setNonItemWiseAccordan,
  nonItems,
  setNonItems,
  setInitNonItemTableData,
  setDeleteNonEntriesModal,

  nonRowIndex,
  setNonRowIndex,
  accNames,
  data,
  setAccNames,
  invoiceEntry,

  setDisplayAllAccounts,
  displayAllAccounts,
  Type,
  registrationType,
  companyData,
  setBackdropOpen,
  viewMode,

  setOpenDropdowns,
  tabelCellClass,

  setIsNonItemFocusRow,

  nonItemValid,
  setNonItemValid,
  partyType,
  handleResetScroll,
  setTableErrArr,
  newNonItemObj,
  fixedTaxObj,
  items,
  companyState,
}) {
  const classes = useStyles();
  const { expenceAccNames, expenceAllAcc } = UseLedgerAccount(Type);
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  const companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
    const isCessFlag=getCompany?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
  const nonItemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Income/Sales Account',
      label: 'Income/Sales Account',
      width: 180,
      colSpan: 3,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'GST',
      label:
        (partyType === 'CUSTOMER' || Type === 'Pos') && companyType === 3 ? (
          <>
            Comp.
            <br />
            GST (%)
          </>
        ) : (
          'GST (%)'
        ),
      width: 40,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Description',
      label: 'Description',
      width: 200,
      align: 'left',
      colSpan: 5,
      currency: '',
      required: '',
    },
    {
      id: 'Taxable Amt',
      label: 'Taxable Amt',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'GST Amt',
      label: 'GST Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Cess',
      label: 'Cess',
      width: 100,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const nonItemWiseHeaderWithoutCess = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Income/Sales Account',
      label: 'Income/Sales Account',
      width: 180,
      colSpan: 3,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'GST',
      label:
        (partyType === 'CUSTOMER' || Type === 'Pos') && companyType === 3 ? (
          <>
            Comp.
            <br />
            GST (%)
          </>
        ) : (
          'GST (%)'
        ),
      width: 40,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Description',
      label: 'Description',
      width: 200,
      align: 'left',
      colSpan: 5,
      currency: '',
      required: '',
    },
    {
      id: 'Taxable Amt',
      label: 'Taxable Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'GST Amt',
      label: 'GST Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const taxTypeNonItemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Income/Sales Account',
      label: 'Income/Sales Account',
      width: 200,
      colSpan: 3,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Description',
      label: 'Description',
      width: 200,
      align: 'left',
      colSpan: 5,
      currency: '',
      required: '',
    },
    {
      id: 'Taxable Amt',
      label: 'Taxable Amt',
      width: 140,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },

    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const compositeTaxTypeNonItemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Income/Sales Account',
      label: 'Income/Sales Account',
      width: 200,
      colSpan: 3,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Description',
      label: 'Description',
      width: 200,
      align: 'left',
      colSpan: 5,
      currency: '',
      required: '',
    },
    // {
    //   id: "Taxable Amt",
    //   label: "Taxable Amt",
    //   width: 140,
    //   align: "right",
    //   currency: data?.currency?.sign,
    //   required: <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>,
    // },

    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const unRegisteredNonItemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Income/Sales Account',
      label: 'Income/Sales Account',
      width: 200,
      colSpan: 3,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Description',
      label: 'Description',
      width: 200,
      align: 'left',
      colSpan: 5,
      currency: '',
      required: '',
    },
    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const compositeNonItemWiseHeader = [
    {
      id: 'S.No',
      label: 'S.No',
      width: 20,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Income/Sales Account',
      label: 'Income/Sales Account',
      width: 180,
      colSpan: 3,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'Reason',
      label: 'Reason',
      width: 140,
      align: 'left',
      currency: '',
      required: '',
    },

    {
      id: 'GST',
      label:
        (partyType === 'CUSTOMER' || Type === 'Pos') && companyType === 3 ? (
          <>
            Comp.
            <br />
            GST (%)
          </>
        ) : (
          'GST (%)'
        ),
      width: 40,
      align: 'left',
      currency: '',
      required: <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>,
    },
    {
      id: 'HSN/SAC',
      label: 'HSN/SAC',
      width: 120,
      align: 'left',
      currency: '',
      required: '',
    },
    {
      id: 'Description',
      label: 'Description',
      width: 200,
      align: 'left',
      colSpan: 5,
      currency: '',
      required: '',
    },

    {
      id: 'Net Amt',
      label: 'Net Amt',
      width: 120,
      align: 'right',
      currency: data?.currency?.sign,
      required: '',
    },
    {
      id: 'action',
      label: 'Action',
      width: 40,
      align: 'center',
      currency: '',
      required: '',
    },
  ];
  const focuscellRef = useRef(null);
  const [addEvent, setAddEvent] = useState(false);
  const [openAddAccountModal, setOpenAddAccountModal] = useState(false);
  const [modalEvent, setModalEvent] = useState(false);
  const [newPartyID, setNewPartyID] = useState('');
  const [newPartyName, setNewPartyName] = useState('');
  const [selelctedGroupId, setSelectedGroupId] = useState('');
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState('');
  const [updatetedTableRow, setUpdatedTableRow] = useState([]);
  const {
    gstOrCompositeRate,
    compositeRate,
    taxabilityOptions,
    compositeTaxability,
    taxabilityOutsideIndia,
    compositeTaxabilityForCustomer,
    unrSupplierTaxability,
    customerTaxabilityOptions,
  } = useTaxabilityOptions();
  const { filterHSN, setFilterHSN, searchHSNDetails, HSNListboxProps, setRow } = UseHSNMaster({ Type: '', Page: 'NONITEM' });
  let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29];
  accNames =
    getCompany?.relatedcompanydetailsnew?.[0].registrationtype !== 1
      ? [...accNames]
      : accNames.filter((e) => !GSTArrayValues.includes(e.value));

  let compositePercent = getCompany?.relatedcompanydetailsnew?.[0]?.comppercentage;
  //LEDX-4499---->>>
  const handleTaxabilityChange = useHandleTaxabilityChange({
    Type,
  });
  //LEDX-4499---->>>
  async function formatNumbers(index, value, checkedValue) {
    let updatedTableArr = [...nonItems];

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      [value]: (() => {
        let formattedValue = checkedValue;
        if (formattedValue === '.') {
          formattedValue = '0.00';
        }

        if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
          formattedValue = '0';
        }

        if (!isNaN(parseFloat(formattedValue))) {
          formattedValue = parseFloat(formattedValue).toFixed(2);
        }

        return formattedValue;
      })(),
    };

    setNonItems(updatedTableArr);
  }
  // const handleLedgerAccountChange = (e, newValue, index) => {
  //   const updatedTableRow = [...nonItems];

  //   if (!newValue || ["addAccount", "showAllAccounts"].includes(newValue.value))
  //     return;

  //   setNonRowIndex(index);
  //   updatedTableRow[index] = {
  //     ...updatedTableRow[index],
  //     ledgerAccount: newValue,
  //     GSTRate:
  //       registrationType === 1
  //         ? 0
  //         : companyType === 3
  //         ? partyType === "CUSTOMER" || Type === "Pos"
  //           ? compositePercent
  //           : ""
  //         : "",
  //   };

  //   if (fixedTaxObj.label) {
  //     updatedTableRow[index].taxability = {
  //       label: fixedTaxObj.label,
  //       value: fixedTaxObj.value,
  //     };
  //   }
  //   getAccountGSTDetails(newValue)
  //   setNonItems(updatedTableRow);

  // };
  const handleLedgerAccountChange = (e, newValue, index) => {
    getAccountGSTDetails(newValue, index);
  };

  const handleLedgerAccountKeyDown = (e, index) => {
    const warMsg = 'Ledger Account is required';
    const currentId = 'ledgerAccount' + index;
    const updatedTableArr = [...items];
    const zeroItemIndex =
      updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
        ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
        : updatedTableArr.findIndex((row) => row.itemCode.value !== '');
    const prevID = 'itemCode' + zeroItemIndex;
    const nextId =
      Type === 'CreditNote' || Type === 'DebitNote'
        ? 'nonreason' + index
        : companyType == 3
        ? 'nonhsnCode' + index
        : registrationType == 1
        ? 'description' + index
        : [2, 3, 5].includes(data?.taxability?.value)
        ? 'nonhsnCode' + index
        : 'nonGSTRate' + index;
    handleAutoCompleteKeyDown(e, currentId, nextId, true, warMsg, prevID);
  };
  const handleLedgerAccountInputChange = (event, newInputValue) => {
    if (newInputValue.trim().length > 0 && !displayAllAccounts) {
      setDisplayAllAccounts(true);
    } else if (newInputValue.trim().length === 0 && displayAllAccounts) {
      setDisplayAllAccounts(false);
    }
  };
  const handleReasonChange = (e, index) => {
    const value = e.target.value;
    const updatedTableRow = [...nonItems];

    updatedTableRow[index] = {
      ...updatedTableRow[index],
      reason: value,
    };

    setNonRowIndex(index);
    setNonItems(updatedTableRow);
  };

  const handleReasonKeyDown = (e, index) => {
    const taxType = [2, 3, 5, 7, 9].includes(Number(data?.taxability?.value));
    const warMsg = '';
    const currentId = `nonreason${index}`;
    const nextId =
      companyType === 3 || taxType ? `nonhsnCode${index}` : registrationType === 1 ? `description${index}` : `nonGSTRate${index}`;
    const prevID = `ledgerAccount${index}`;

    handleTextKeyDown(e, currentId, nextId, false, warMsg, prevID);
  };
  const handleGSTRateChange = (newValue, index, manualGSTFlag) => {
    if (manualGSTFlag === 0) {
      if (newValue) {
        setTableAmountsByGSTRate(newValue, index, manualGSTFlag);
      } else {
        setTableAmountsByManualGTRate(newValue, index, manualGSTFlag);
      }
    } else {
      setTableAmountsByManualGTRate(newValue, index, manualGSTFlag);
    }

    setNonRowIndex(index);
  };

  const handleGSTRateKeyDown = (e, index) => {
    const warMsg = 'GST Rate is required';
    const currentId = `nonGSTRate${index}`;
    const nextId = `nonhsnCode${index}`;
    const prevID = Type === 'CreditNote' || Type === 'DebitNote' ? `nonreason${index}` : `ledgerAccount${index}`;

    handleAutoCompleteKeyDown(e, currentId, nextId, true, warMsg, prevID);
  };

  const handleHSNCodeChange = (e, newValue, index) => {
    const updatedTableRow = [...nonItems];
    if (newValue !== null) {
      setNonRowIndex(index);
      updatedTableRow[index] = {
        ...updatedTableRow[index],
        HSN: newValue,
      };
    } else {
      updatedTableRow[index] = {
        ...updatedTableRow[index],
        HSN: {
          label: '',
          value: '',
          companyID: '',
          hsnID: '',
          codeType: '',
          description: '',
        },
      };
    }
    setNonItems(updatedTableRow);
  };

  const handleHSNInputChange = (e, newValue) => {
    setRow(0);
    if (newValue) {
      searchHSNDetails(newValue, 0, 20);
    } else {
      searchHSNDetails('', 0, 20);
    }
  };

  const handleHSNKeyDown = (e, index) => {
    const warMsg = 'HSN/SAC Code is required';
    const currentId = `nonhsnCode${index}`;
    const nextId = `description${index}`;

    const prevID =
      Type === 'DebitNote' || Type === 'CreditNote'
        ? `nonreason${index}`
        : companyType === 3
        ? `ledgerAccount${index}`
        : registrationType === 1
        ? `ledgerAccount${index}`
        : `nonGSTRate${index}`;

    const required = companyType === 2 && partyType === 'CUSTOMER' ? true : false;
    // EInvoiceFlag &&
    // Type === "Sales" &&
    // // &&
    // // data.partyCategory !== "UB"
    // registrationType !== 1;

    handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleDescriptionChange = (e, index) => {
    const updatedTableRow = [...nonItems];
    const value = e.target.value;
    setNonRowIndex(index);
    updatedTableRow[index] = {
      ...updatedTableRow[index],
      description: value,
    };
    setNonItems(updatedTableRow);
  };

  const handleDescriptionKeyDown = (e, index) => {
    const warMsg = '';

    const currentId = `description${index}`;
    const nextId = registrationType !== 1 ? `nontaxableAMount${index}` : `nontaxableAMount${index}`;

    const prevID =
      registrationType === 1
        ? Type === 'CreditNote' || Type === 'DebitNote'
          ? 'nonreason'
          : `ledgerAccount${index}`
        : `nonhsnCode${index}`;

    const required = false;

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleTaxableAmountChange = (val, index) => {
    let value = Number(val);
    
    const regex = /^[0-9]+$/;

    if (!/^-?\d*(?:\.\d*)?$/.test(value)) {
      return;
    }
    if (!/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    const numericValue = parseFloat(value);
    const maxLimit = 1000000000; // 10 billion

    if (numericValue > maxLimit) {
      return;
    }

    if (value !== '' || regex.test(value)) {
      setTableAmountsBytaxAmt(value, index);
      setNonRowIndex(index);
    } else {
      setTableAmountsBytaxAmt(0, index);
    }
  };

  const handleTaxableAmountBlur = (index) => {
    const updatedTableArr = [...nonItems];
    formatNumbers(index, 'taxableAMount', updatedTableArr[index]?.taxableAMount);
  };

  const handleTaxableAmountKeyDown = (e, index) => {
    const warMsg = registrationType !== 1 && registrationType !== 3 ? 'Taxable Amount is required' : 'Net Amount is required';

    const currentId = `nontaxableAMount${index}`;
    const nextId = [2, 3, 5,7,9].includes(data?.taxability?.value) ? `nonnetAmount${index}` : `nonIGST${index}`;

    const prevID = `description${index}`;

    const required = true;
    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  const handleGSTCessChange = (val, index) => {
    let value = Number(val);
    // value = value.replace(/,/g, '');
    const regex = /^[0-9]+$/;

    if (!/^-?\d*(?:\.\d*)?$/.test(value)) {
      return;
    }
    if (!/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    const numericValue = parseFloat(value);
    const maxLimit = 10000000000; // 10 billion

    if (numericValue > maxLimit) {
      return;
    }

    if (value !== '' || regex.test(value)) {
      setTableAmountsByGSTCess(value, index);
      setNonRowIndex(index);
    } else {
      setTableAmountsByGSTCess(0, index);
    }
  };

  const handleGSTCessBlur = (index) => {
    const updatedTableArr = [...nonItems];
    formatNumbers(index, 'GSTCess', updatedTableArr[index]?.GSTCess);
  };
  const handleGstAmtBlur = (index) => {
    const updatedTableArr = [...nonItems];
    formatNumbers(index, 'IGST', updatedTableArr[index]?.IGST);
  };
  const handleGSTCessKeyDown = (e, index) => {
    const warMsg = '';
    const currentId = `nongstCess${index}`;
    const nextId = `nonnetAmount${index}`;
    const prevID = `nonIGST${index}`;
    const required = false;

    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
  };
  async function getTableDataOfSales(invoiceEntry) {
    // setBackdropOpen(true);
    let arr = [];
    let taxObj = { label: '', value: '' };
    let sortedItems = invoiceEntry?.relatedinvoicelinenonitems?.sort((a, b) => a.lineitemnumber - b.lineitemnumber);
    await Promise.all(
      sortedItems?.map(async (ele, ind) => {
        if (ele?.manualgst === 0) {
          if ([2, 3, 5, 7, 9].includes(Number(invoiceEntry?.invoicetaxabletypecd))) {
            ele.IGST = 0;
          } else {
            ele.IGST = (Number(ele.taxableamount) * Number(ele.gstrate)) / 100;
            ele.IGST = Number(ele.IGST) / 2;
            ele.IGST = Math.round(ele.IGST * 100) / 100;
            ele.IGST = ele.IGST * 2;
            ele.IGST = ele.IGST > 0 ? ele.IGST : 0;
          }
        } else {
          ele.IGST = ele?.gstamount;
        }

        let accountobj = {};
        let hsnobj254 = {};
        let hsnCode = {
          label: '',
          value: '',
          companyID: '',
          hsnID: '',
          codeType: '',
          description: '',
        };

        if (ele.hsnsaccode != 0) {
          hsnCode = {
            label: `${ele.hsnsaccode} - ${ele.hsndescription}`,
            value: `${ele.hsnsaccode}`,
            companyID: ele.companyid,
            hsnID: ele.hsnsacid,
            codeType: ele.hsncodetype,
            description: ele.hsndescription,
          };
        }

        accountobj = {
          label: ele?.incomeaccountname,
          value: ele?.incomeaccountid,
        };

        arr.push({
          id: ele.invoiceitemid,
          ledgerAccount: accountobj,
          HSN: hsnCode,
          description: ele.itemdescription,
          taxableAMount: ele.taxableamount,
          taxability: taxObj,
          GSTRate: ele?.gstrate,
          manualGSTFlag: ele?.manualgst,
          IGST: ele.IGST,
          CGST: '0.00',
          SGST: '0.00',
          GSTCess: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.invoicetaxabletypecd)) ? 0 : ele?.cessamount,
          netAmount: [2, 3, 5, 4, 7, 9].includes(Number(invoiceEntry?.invoicetaxabletypecd)) ? ele?.taxableamount : ele.netamount,
          invoiceitemid: ele?.invoiceitemid,
          editable: false,
          new: false,
          cessType:ele.cesstype,
          manualCess:ele.manualcess,
          cessRate:ele.cessrate
        });
      })
    );

    const sortedArray = [...arr].sort((a, b) => a.id - b.id);
    setNonItems([...sortedArray, newNonItemObj]);
    if (setInitNonItemTableData) {
      setInitNonItemTableData([...sortedArray, newNonItemObj]);
    }

    setBackdropOpen(false);
  }
  async function getTableDataOfPurchase(invoiceEntry) {
    // setBackdropOpen(true);
    if (invoiceEntry?.relatedpurchaselinenonitems?.length > 0) {
      let arr = [];
      let taxObj = { label: '', value: '' };
      let accountobj = { label: '', value: '' };
      await Promise.all(
        invoiceEntry?.relatedpurchaselinenonitems.map(async (ele, ind) => {
          if (ele?.manualgst === 0) {
            if ([2, 3, 5, 7, 9].includes(Number(invoiceEntry?.purchasegsttypecd))) {
              ele.IGST = 0;
            } else {
              ele.IGST = (Number(ele.taxableamount) * Number(ele.gstrate)) / 100;
              ele.IGST = Number(ele.IGST) / 2;
              ele.IGST = Math.round(ele.IGST * 100) / 100;
              ele.IGST = ele.IGST * 2;
              ele.IGST = ele.IGST > 0 ? ele.IGST : 0;
            }
          } else {
            ele.IGST = ele?.gstamount;
          }

          accountobj = {
            label: ele?.purchaseaccountname,
            value: ele?.purchaseaccountid,
          };
          let hsnCode = {
            label: '',
            value: '',
            companyID: '',
            hsnID: '',
            codeType: '',
            description: '',
          };
          if (ele.hsnsaccode != 0) {
            hsnCode = {
              label: `${ele.hsnsaccode} - ${ele.hsndescription}`,
              value: `${ele.hsnsaccode}`,
              companyID: ele.companyid,
              hsnID: ele.hsnsacid,
              codeType: ele.hsncodetype,
              description: ele.hsndescription,
            };
          }
          arr.push({
            id: ele.purchaseitemid,
            ledgerAccount: accountobj,
            HSN: hsnCode,
            description: ele.itemdescription,
            taxableAMount: ele.taxableamount,
            taxability: taxObj,
            GSTRate: ele?.gstrate,
            manualGSTFlag: ele?.manualgst,
            IGST: ele.IGST,
            CGST: '0.00',
            SGST: '0.00',
            GSTCess: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.purchasegsttypecd)) ? 0 : ele?.cessamount,
            invoiceitemid: ele?.invoiceitemid,
            netAmount: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.purchasegsttypecd)) ? ele?.taxableamount : ele.netamount,
            purchaseitemid: ele?.purchaseitemid,
              cessType:ele.cesstype,
          manualCess:ele.manualcess,
          cessRate:ele.cessrate,
         
            new: false,
            
          });
        })
      );
      const sortedArray = [...arr].sort((a, b) => a.id - b.id);
      setNonItems([...sortedArray, newNonItemObj]);
      if (setInitNonItemTableData) {
        setInitNonItemTableData([...sortedArray, newNonItemObj]);
      }
    }
    setBackdropOpen(false);
  }
  async function getTableDataOfCrDr(invoiceEntry) {
    try {
      // setBackdropOpen(true);
      if (invoiceEntry?.relatedcrdrnotelinenonitems.length > 0) {
        let arr = [];
        let taxObj = { label: '', value: '' };
        await Promise.all(
          invoiceEntry?.relatedcrdrnotelinenonitems.map(async (ele, ind) => {
            let accountobj = { label: '', value: '' };

            accountobj = {
              label: ele?.ledgeraccountname,
              value: ele?.ledgeraccountid,
            };

            let hsnCode = {
              label: '',
              value: '',
              companyID: '',
              hsnID: '',
              codeType: '',
              description: '',
            };
            let hsnobj254 = {};

            if (ele.hsnsaccode != 0) {
              hsnCode = {
                label: `${ele.hsnsaccode} - ${ele.hsndescription}`,
                value: `${ele.hsnsaccode}`,
                companyID: ele.companyid,
                hsnID: ele.hsnsacid,
                codeType: ele.hsncodetype,
                description: ele.hsndescription,
              };
            }
            if (ele?.manualgst === 0) {
              if ([2, 3, 5, 7, 9].includes(Number(invoiceEntry?.gsttypecd))) {
                ele.IGST = 0;
              } else {
                ele.IGST = (Number(ele.taxableamount) * Number(ele.gstrate)) / 100;
                ele.IGST = Number(ele.IGST) / 2;
                ele.IGST = Math.round(ele.IGST * 100) / 100;
                ele.IGST = ele.IGST * 2;
                ele.IGST = ele.IGST > 0 ? ele.IGST : 0;
              }
            } else {
              ele.IGST = ele?.gstamount;
            }
            const taxTypes = invoiceEntry?.partytypecd === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
            arr.push({
              id: ele.crdrnoteitemid,
              ledgerAccount: accountobj,
              HSN: hsnCode,
              description: ele.itemdescription,
              taxableAMount: ele.taxableamount,
              GSTRate: ele.gstrate,
              manualGSTFlag: ele?.manualgst,
              taxability: taxObj,
              reason: ele.reason ?? '',
              IGST: ele.IGST,
              CGST: '0.00',
              SGST: '0.00',
              GSTCess: [2, 3, 5, 7, 9].includes(Number(invoiceEntry?.gsttypecd)) ? 0 : ele.gstcess,
              crdrnoteitemid: ele?.crdrnoteitemid,
              // netAmount:[2, 3, 5, 7, 9].includes(Number(invoiceEntry?.gsttypecd))?ele?.taxableamount: ele.netamount,
              netAmount: taxTypes.includes(Number(invoiceEntry?.gsttypecd)) ? ele?.taxableamount : ele.netamount,
                cessType:ele.cesstype,
          manualCess:ele.manualcess,
          cessRate:ele.cessrate,
              editable: false,
              new: false,
            });
          })
        );
        const sortedArray = [...arr].sort((a, b) => a.id - b.id);
        setNonItems([...sortedArray, newNonItemObj]);
        if (setInitNonItemTableData) {
          setInitNonItemTableData([...sortedArray, newNonItemObj]);
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  function saveChangesInNonRows(index) {
    let isvalid = true;
    let requireds = [];
    let errorArr = [];
    let invalids = '';
    let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;

    const updatedTableRow = [...nonItems];
    if (updatedTableRow.length > 0) {
      updatedTableRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value === '') {
          isvalid = false;
          errorArr.push('ledgerAccount' + ind);
          requireds.push('Ledger Account');
        }
        if (registrationType !== 1) {
          if (
            data?.taxability?.value == 1 ||
            data?.taxability?.value == 4 ||
            data?.taxability?.value == 6 ||
            data?.taxability?.value == 8 ||
            data?.taxability?.value == 9 ||
            data?.taxability?.value == 7 ||
            data?.taxability?.value === ''
          ) {
            if (ele?.GSTRate === '') {
              isvalid = false;
              errorArr.push('nonGSTRate' + ind);
              requireds.push('GST Rate');
            }
          }
        }
        if (companyType === 2 && partyType === 'CUSTOMER') {
          if (
            ele?.HSN?.value === '' ||
            ele?.HSN?.value === undefined ||
            ele?.HSN?.value === null
            //   &&
            // EInvoiceFlag &&
            // Type === "Sales"
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            errorArr.push('nonhsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
        if (ele?.taxableAMount === '' || ele?.taxableAMount == 0) {
          isvalid = false;
          if (registrationType !== 1) {
            requireds.push('Taxable Amount');
            errorArr.push('nontaxableAMount' + ind);
          } else {
            errorArr.push('nontaxableAMount' + ind);
            requireds.push('Net Amount');
          }
        }
      });

      setTableErrArr(errorArr);

      setNonItemValid(isvalid);
      if (isvalid) {
        let arr = [...updatedTableRow];

        setNonItems([...arr, newNonItemObj]);
        setAddEvent(true);
        handleResetScroll();

        setNonRowIndex('');
      } else {
        setIsNonItemFocusRow(false);
        if (requireds.length >= 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
      }
    } else {
      setNonItems([newNonItemObj]);
    }
  }

  function noncloseChangesInRows(ind) {
    let arr = [...nonItems].filter((item, index) => {
      if (ind != index) {
        return item;
      }
    });
    setNonItems(arr);
  }

  function setTableAmountsBytaxAmt(value, index) {
    const updatedTableRow = [...nonItems];
    let netAmt = 0;
    let igstAmt = 0;
    let cessAmt=0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
    if (registrationType === 1) {
      igstAmt = 0;
      cessAmt=0;
      netAmt = Number(value) > 0 ? Number(value) : 0;
    } else {
      if (updatedTableRow[index]?.manualGSTFlag === 0) {
        if (
          updatedTableRow[index]?.GSTRate !== '' &&
          Number(updatedTableRow[index]?.GSTRate) > 0 &&
          value &&
          ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
        ) {
          igstAmt = Number(value) * Number(updatedTableRow[index]?.GSTRate / 100);
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
        }
      } else {
        igstAmt = updatedTableRow[index]?.IGST;
      }
      //   if (updatedTableRow[index]?.manualCess === 0) {
      //      if (
      //     updatedTableRow[index]?.cessRate !== '' && updatedTableRow[index]?.cessType==="Percentage" &&
      //     Number(updatedTableRow[index]?.cessRate) > 0 &&
      //     value &&
      //     ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
      //   ) {
      //     cessAmt = Number(value) * Number(updatedTableRow[index]?.cessRate / 100);
         
      //   }else{
      //      cessAmt = updatedTableRow[index]?.GSTCess;
      //   }
      // } else {
      //   cessAmt = updatedTableRow[index]?.GSTCess;
      // }
      if (updatedTableRow[index]?.manualCess === 0) {
  if (
    updatedTableRow[index]?.cessRate !== '' &&
    updatedTableRow[index]?.cessType === "Percentage" &&
    Number(updatedTableRow[index]?.cessRate) > 0 &&
    ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
  ) {
    cessAmt = Number(value) * Number(updatedTableRow[index]?.cessRate / 100);
  } else {
    // correct fix → cess must be 0 when taxable value = 0
    cessAmt = 0;
  }
} else {
  cessAmt = Number(value)>0?updatedTableRow[index]?.GSTCess:0;
}

        
      netAmt = Number(value) + Number(igstAmt) + Number(cessAmt);
    }
    // if (netAmt > 999999999) {
    //   showWarningSnackbar('The Net Amount should be less than 100 crore');
    //   return;
    // }
    updatedTableRow[index] = {
      ...updatedTableRow[index],
      taxableAMount: value,
      IGST: igstAmt,
      netAmount:
        //LEDX-4673
        (registrationType === 3 && partyType === 'CUSTOMER') ||
        ((partyType === 'CUSTOMER' || Type === 'Pos') && data.reverseChargeFlag === 1) ||
        // [2, 3, 5, 7, 9].includes(data?.taxability?.value)
        taxTypes.includes(data?.taxability?.value)
          ? value
          : netAmt,
      manualGSTFlag: updatedTableRow[index]?.manualGSTFlag,
      manualCess:updatedTableRow[index]?.manualCess,
      GSTCess:cessAmt
    };
    setNonItems(updatedTableRow);
  }
  function setTableAmountsByGSTCess(value, index) {
    const updatedTableRow = [...nonItems];
    let netAmt = 0;
    let igstAmt = 0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
    if (updatedTableRow[index]?.manualGSTFlag === 0) {
      if (
        updatedTableRow[index]?.GSTRate !== '' &&
        Number(updatedTableRow[index]?.GSTRate) > 0 &&
        updatedTableRow[index]?.taxableAMount &&
        ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
      ) {
        igstAmt = Number(updatedTableRow[index]?.taxableAMount) * Number(updatedTableRow[index]?.GSTRate / 100);
        igstAmt = Number(igstAmt) / 2;
        igstAmt = Math.round(igstAmt * 100) / 100;
        igstAmt = igstAmt * 2;
      }
    } else {
      igstAmt = updatedTableRow[index]?.IGST;
    }
    netAmt = Number(updatedTableRow[index]?.taxableAMount) + Number(igstAmt) + Number(value);
    // if (netAmt > 999999999) {
    //   showWarningSnackbar('The Net Amount should be less than 100 crore');
    //   return;
    // }
    updatedTableRow[index] = {
      ...updatedTableRow[index],
      GSTCess: value,
      IGST: igstAmt,
      netAmount:
        //LEDX-4673
        (registrationType === 3 && partyType === 'CUSTOMER') ||
        ((partyType === 'CUSTOMER' || Type === 'Pos') && data.reverseChargeFlag === 1) ||
        // [2, 3, 5, 7, 9].includes(data?.taxability?.value)
        taxTypes.includes(data?.taxability?.value)
          ? updatedTableRow[index]?.taxableAMount
          : netAmt,
      manualGSTFlag: updatedTableRow[index]?.manualGSTFlag,
      manualCess:1
    };
    setNonItems(updatedTableRow);
  }
  function setTableAmountsByGSTRate(value, index, manualGSTFlag) {
    const updatedTableRow = [...nonItems];
    let netAmt = 0;
    let igstAmt = 0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
    if (
      value?.id !== '' &&
      Number(value?.id) > 0 &&
      updatedTableRow[index]?.taxableAMount &&
      ![2, 3, 5, 7, 9].includes(data?.taxability?.value)
    ) {
      igstAmt = Number(updatedTableRow[index]?.taxableAMount) * Number(value?.id / 100);
      igstAmt = Number(igstAmt) / 2;
      igstAmt = Math.round(igstAmt * 100) / 100;
      igstAmt = igstAmt * 2;
    }
    netAmt = Number(updatedTableRow[index]?.taxableAMount) + Number(igstAmt) + Number(updatedTableRow[index]?.GSTCess);
    // if (netAmt > 999999999) {
    //   showWarningSnackbar('The Net Amount should be less than 100 crore');
    //   return;
    // }
    updatedTableRow[index] = {
      ...updatedTableRow[index],
      GSTRate: value ? value.id : '',
      IGST: igstAmt,
      netAmount:
        //LEDX-4673
        (registrationType === 3 && partyType === 'CUSTOMER') ||
        ((partyType === 'CUSTOMER' || Type === 'Pos') && data.reverseChargeFlag === 1) ||
        // [2, 3, 5, 7, 9].includes(data?.taxability?.value)\
        taxTypes.includes(data?.taxability?.value)
          ? updatedTableRow[index]?.taxableAMount
          : netAmt,
      manualGSTFlag: manualGSTFlag,
       manualCess:updatedTableRow[index]?.manualCess
    };
    setNonItems(updatedTableRow);
  }

  function setTableAmountsByManualGTRate(value, index, manualGSTFlag) {
    const updatedTableRow = [...nonItems];
    let netAmt = 0;
    let igstAmt = 0;
    const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];
    if (value && ![2, 3, 5, 7, 9].includes(data?.taxability?.value)) {
      igstAmt = value;
    } else {
      igstAmt = 0;
    }
    netAmt = Number(updatedTableRow[index]?.taxableAMount) + Number(igstAmt) + Number(updatedTableRow[index]?.GSTCess);
    // if (netAmt > 999999999) {
    //   showWarningSnackbar('The Net Amount should be less than 100 crore');
    //   return;
    // }
    updatedTableRow[index] = {
      ...updatedTableRow[index],
      IGST: igstAmt,
      netAmount:
        //LEDX-4673
        (registrationType === 3 && partyType === 'CUSTOMER') ||
        ((partyType === 'CUSTOMER' || Type === 'Pos') && data.reverseChargeFlag === 1) ||
        // [2, 3, 5, 7, 9].includes(data?.taxability?.value)\
        taxTypes.includes(data?.taxability?.value)
          ? updatedTableRow[index]?.taxableAMount
          : netAmt,
      manualGSTFlag: manualGSTFlag,
      manualCess:updatedTableRow[index]?.manualCess
    };
    setNonItems(updatedTableRow);
  }

  useEffect(() => {
    if (invoiceEntry?.length !== 0 && partyType !== '') {
      // setBackdropOpen(true);
      if (Type === 'Sales') {
        getTableDataOfSales(invoiceEntry);
      }
      if (Type === 'Purchase') {
        getTableDataOfPurchase(invoiceEntry);
      }
      if (Type === 'DebitNote' || Type === 'CreditNote') {
        getTableDataOfCrDr(invoiceEntry);
      }

      setBackdropOpen(false);
    }
  }, [invoiceEntry, Type]);

  useEffect(() => {
    setOpenDropdowns((prev) => ({
      ...prev,
      itemcode: false,
      itemName: false,
      gstRate1: false,
      taxability1: false,
      hsnCode1: false,
      unit: false,
      ledgerAccount: false,
      gstRate2: false,
      taxability2: false,
      hsnCode2: false,
    }));
  }, [openAddAccountModal, openHsnModal]);
  const textFieldRef = useRef(null);

  const scrollToField = () => {
    const element = textFieldRef.current;
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  };
  function handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && (e.target.value === '' || e?.target?.value == 0)) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  function handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (
        required &&
        (e.target.value === '' || e.target.value === null || e.target.value === undefined) &&
        isAutocompleteOpen &&
        !activeDescendantId
      ) {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  useEffect(() => {
    let updateTableRow = [...nonItems];
    const zeroItemIndex = updateTableRow.findIndex((row) => row.ledgerAccount?.value === '');
    if (addEvent) {
      const element = document.getElementById(`ledgerAccount${zeroItemIndex}`);
      if (element) {
        element.focus();
      }
      setAddEvent(false);
    }
  }, [addEvent, nonItems]);
  async function getAccountGSTDetails(newValue, index) {
    try {
      if (!newValue || ['addAccount', 'showAllAccounts'].includes(newValue.value)) return;

      const updatedTableRow = [...nonItems];
      setNonRowIndex(index);
      updatedTableRow[index] = {
        ...updatedTableRow[index],
        ledgerAccount: newValue,
        GSTRate: registrationType === 1 ? 0 : companyType === 3 ? (partyType === 'CUSTOMER' || Type === 'Pos' ? compositePercent : '') : '',
      };

      if (fixedTaxObj.label) {
        updatedTableRow[index].taxability = {
          label: fixedTaxObj.label,
          value: fixedTaxObj.value,
        };
      }
      const resLedger = await API.graphql(graphqlOperation(getLedgerGSTData, { accountsid: newValue?.value }));

      const gstDetail = resLedger?.data?.getAccountMaster?.relatedaccountgstdetails?.[0];
      const taxability = await displayDefaultTaxability(gstDetail?.taxability ?? '');
      let cessAmtByType=0;
      let cessType='Amount';
      let cessRate='';
      let netAmt = 0;
      let igstAmt = 0;
      let cessAmt = 0;
      let gstRate =
        registrationType === 1
          ? 0
          : companyType === 3 && partyType === 'CUSTOMER'
          ? compositePercent
          : gstDetail
          ? gstDetail?.gstrate
          : updatedTableRow[index].GSTRate;
       if (gstDetail?.gstcompensationtype === "Percentage") {
        cessRate=gstDetail?.cessamount;
        cessType=gstDetail?.gstcompensationtype;
   cessAmtByType =
    (Number(updatedTableRow[index].taxableAMount) *
      Number(cessRate)) /
    100;

      cessAmtByType = Number(cessAmtByType.toFixed(2)); 
} else {
  cessType='Amount';
  cessRate='';
       cessAmtByType = Number(Number(gstDetail?.cessamount).toFixed(2));
}

      cessAmt =
        registrationType === 1
          ? 0
          : Type === 'Sales' && isCessFlag === 0
          ? 0
          : companyType === 3 && partyType === 'CUSTOMER'
          ? 0
          : gstDetail
          ? cessAmtByType
          : 0;
      const taxTypes = partyType === 'CUSTOMER' || Type === 'Pos' ? [2, 3, 5, 4, 7, 9] : [2, 3, 5, 7, 9];

      if (gstRate !== '' && Number(gstRate) > 0 && updatedTableRow[index]?.taxableAMount && ![2, 3, 5, 7, 9].includes(taxability?.value)) {
        igstAmt = Number(updatedTableRow[index]?.taxableAMount) * Number(gstRate / 100);
        igstAmt = Number(igstAmt) / 2;
        igstAmt = Math.round(igstAmt * 100) / 100;
        igstAmt = igstAmt * 2;
      }

      netAmt = Number(updatedTableRow[index]?.taxableAMount) + Number(igstAmt) + Number(cessAmt);
      let hsnCode = {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      };

      if (gstDetail?.hsnsaccode && gstDetail?.hsnsaccode !== 0) {
        hsnCode = {
          label: `${gstDetail.hsnsaccode} - ${gstDetail.description}`,
          value: `${gstDetail.hsnsaccode}`,
          companyID: gstDetail.companyid,
          hsnID: gstDetail.hsnid,
          codeType: gstDetail.codetype,
          description: gstDetail.description,
        };
      }

      updatedTableRow[index] = {
        ...updatedTableRow[index],
        GSTRate: gstRate ?? updatedTableRow[index].GSTRate,
        HSN: hsnCode,
        GSTCess: cessAmt,
        IGST: igstAmt,
        netAmount:
          //LEDX-4673
          (registrationType === 3 && partyType === 'CUSTOMER') ||
          ((partyType === 'CUSTOMER' || Type === 'Pos') && data.reverseChargeFlag === 1) ||
          taxTypes.includes(taxability?.value)
            ? updatedTableRow[index]?.taxableAMount
            : netAmt,
        manualGSTFlag: 0,
        cessType:cessType,
        cessRate:cessRate,
        manualCess:0,
      };

      setNonItems(updatedTableRow);
    } catch (error) {
      console.log('error', error);
    }
  }

  //LEDX-4499 changes---->>
  function displayDefaultTaxability(value) {
    let taxObj = { label: '', value: '' };
    let checkTaxableOptions =
      companyType == 3 && partyType === 'CUSTOMER'
        ? compositeTaxabilityForCustomer
        : companyType == 3 && partyType === 'SUPPLIER'
        ? ['OC', 'UB'].includes(data?.partyCategory)
          ? unrSupplierTaxability
          : compositeTaxability
        : data.placeOfSupply.value === 96
        ? taxabilityOutsideIndia
        : data?.partyCategory === 'SEZ'
        ? customerTaxabilityOptions
        : data?.partyCategory === 'UB' && partyType === 'SUPPLIER'
        ? unrSupplierTaxability
        : companyType === 3
        ? compositeTaxability
        : taxabilityOptions;
    if (registrationType !== 1 && !data?.taxability?.value) {
      checkTaxableOptions.map((ele) => {
        if (Number(ele?.value) === Number(value)) {
          taxObj = { label: ele?.label, value: ele?.value };
        }
      });
      if (taxObj) {
        handleTaxabilityChange(taxObj);
        const element = document?.getElementById('taxability');
        element?.focus();
        return taxObj;
      }
    } else {
      return data?.taxability;
    }
  }
  //LEDX-4499 changes---->>
  return (
    <>
      <TableHead>
        <TableRow
          sx={{
            height: '40px',
            borderBottom: '2px solid rgba(224, 224, 224, 1)',
          }}
          className={tabelCellClass.table}
        >
          <TableCell
            colSpan={
              registrationType === 3
                ? Type === 'Sales' || Type === 'Pos'
                  ? 13 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                  : partyType === 'CUSTOMER'
                  ? 14 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                  : Type === 'Purchase'
                  ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                  : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                : registrationType !== 1
                ? 
                // companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag
                 isCessFlag=== 1
                  ? Type === 'Sales' || Type === 'Purchase'
                    ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                    : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                  : Type === 'Sales'
                  ? 15 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
                  : Type === 'Purchase'
                  ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                  : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                : Type === 'Sales' || Type === 'Purchase'
                ? 11
                : 12
              // - (partyType === "CUSTOMER" ? 0 : 1)
            }
          >
            {' '}
            <IconButton
              sx={{
                fontSize: '15px',
                display: 'flex',
                flexDirection: 'row',
                fontWeight: 600,
                pb: '2px',
                pt: '1px',
                color: 'primary.main',
              }}
            >
              {' '}
              Non Item-wise Entry{' '}
              {nonItemWiseAccordan == true ? (
                <ExpandLessIcon
                  onClick={() => {
                    if (nonItemWiseAccordan == true) {
                      setNonItemWiseAccordan(false);
                    } else {
                      setNonItemWiseAccordan(true);
                    }
                  }}
                />
              ) : (
                <ExpandMoreIcon
                  onClick={() => {
                    if (nonItemWiseAccordan == true) {
                      setNonItemWiseAccordan(false);
                    } else {
                      setNonItemWiseAccordan(true);
                    }
                  }}
                />
              )}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow sx={{ height: '40px' }} className={tabelCellClass.table}>
          {nonItemWiseAccordan === true &&
            (registrationType === 3 && (Type === 'Sales' || Type === 'Pos' || partyType === 'CUSTOMER')
              ? data?.taxability?.value === 2 || data?.taxability?.value === 3 || data?.taxability?.value === 5
                ? compositeTaxTypeNonItemWiseHeader
                : compositeNonItemWiseHeader
              : registrationType === 1
              ? unRegisteredNonItemWiseHeader
              :
              //  companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag 
              isCessFlag
              === 0 && Type === 'Sales'
              ? data?.taxability?.value === 2 || data?.taxability?.value === 3 || data?.taxability?.value === 5
                ? taxTypeNonItemWiseHeader
                : nonItemWiseHeaderWithoutCess
              : data?.taxability?.value === 2 || data?.taxability?.value === 3 || data?.taxability?.value === 5
              ? taxTypeNonItemWiseHeader
              : nonItemWiseHeader
            ).map((column, ind) => {
              if (Type === 'Purchase') {
                if (column.id === 'Income/Sales Account') {
                  column.label = 'Expense/Purchase Account';
                  column.id = 'Expense/Purchase Account';
                }
              }
              if (column.id === 'HSN/SAC') {
                if (
                  // Type === "Sales" &&
                  // EInvoiceFlag &&
                  // registrationType !== 1
                  companyType === 2 &&
                  partyType === 'CUSTOMER'
                  // &&
                  // data.partyCategory !== "UB"
                ) {
                  column.required = <span style={{ color: '#e55353', paddingLeft: '2px' }}>*</span>;
                } else {
                  column.required = '';
                }
              }
              // if (
              //   partyType === "SUPPLIER" &&
              //   (column.id === "Expense/Purchase Account" ||
              //     column.id === "Income/Sales Account")
              // ) {
              //   column.colSpan = column.colSpan - 1;
              // }
              if (Type === 'Purchase' || Type === 'Sales') {
                if (column.id !== 'Reason') {
                  return (
                    <TableCell
                      key={ind}
                      colSpan={column.colSpan}
                      align={column.align}
                      width={column.width}
                      sx={{
                        fontWeight: 600,
                        fontSize: '13px',
                        color: 'input.label',
                        backgroundColor: 'background.tablebg',
                        position: column.id === 'action' ? 'sticky' : '',
                        right: column.id === 'action' ? 0 : '',

                        zIndex: column.id === 'action' ? 1 : 0,
                      }}
                    >
                      <span>{column.label} </span>
                      {column.currency !== '' ? <span>({column.currency})</span> : ''}
                      <span>{column.required}</span>
                    </TableCell>
                  );
                }
              } else {
                return (
                  <TableCell
                    key={ind}
                    colSpan={column.colSpan}
                    align={column.align}
                    width={column.width}
                    sx={{
                      fontWeight: 600,
                      fontSize: '13px',
                      color: 'input.label',
                      backgroundColor: 'background.tablebg',
                      position: column.id === 'action' ? 'sticky' : '',
                      right: column.id === 'action' ? 0 : '',

                      zIndex: column.id === 'action' ? 1 : 0,
                    }}
                  >
                    <span>{column.label} </span>
                    {column.currency !== '' ? <span>({column.currency})</span> : ''}
                    <span>{column.required}</span>
                  </TableCell>
                );
              }
            })}
        </TableRow>
      </TableHead>
      {nonItemWiseAccordan == true && (
        <>
          <TableBody className={viewMode == true ? 'disable-interactions' : ''}>
            {nonItems.length > 0 ? (
              nonItems.map((column, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} sx={{ height: '40px' }} className={tabelCellClass.table} key={index}>
                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: '14px',
                        }}
                      >
                        {index + 1}
                      </Typography>
                    </TableCell>
                    <TableCell
                      colSpan={
                        3
                        // - (partyType === "CUSTOMER" ? 0 : 1)
                      }
                      className={
                        // isFocusNonItemRow === false &&
                        column?.ledgerAccount?.label === '' && nonItemValid === false ? tabelCellClass.errorTableCell : ''
                      }
                    >
                      <Tooltip title={column?.ledgerAccount?.label}>
                        <Autocomplete
                          id={'ledgerAccount' + index}
                          ref={focuscellRef}
                          autoFocus
                          openOnFocus
                          className={classes.autocomplete}
                          disableClearable
                          componentsProps={{
                            popper: {
                              style: { width: 'fit-content' },
                            },
                            paper: {
                              style: {
                                maxWidth: '100%',
                                overflowX: 'auto',
                                overflowY: 'auto',
                                whiteSpace: 'nowrap',
                              },
                            },
                          }}
                          ListboxProps={{
  sx: {
     '& .MuiAutocomplete-option': {
        paddingTop: '3px !important',
        paddingBottom: '3px !important',
        minHeight: '25px !important',
      },
  },
}}

                          PopperComponent={(props) => {
                            return (
                              <Popper
                                {...props}
                                style={{
                                  ...props.style,
                                  width: document.getElementById(`ledgerAccount${index}`)?.closest('td')?.offsetWidth || 'auto',
                                  maxWidth: '100%', // Ensure Popper does not exceed the parent container
                                }}
                              />
                            );
                          }}
                          options={
                            displayAllAccounts == false
                              ? [
                                  'Add Accounts',
                                  ...expenceAccNames.sort((a, b) => {
                                    if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
                                    if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
                                    return 0;
                                  }),
                                  'Show All Accounts',
                                ]
                              : [
                                  'Add Accounts',
                                  ...expenceAllAcc.sort((a, b) => {
                                    if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
                                    if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
                                    return 0;
                                  }),
                                  'Show All Accounts',
                                ]
                          }
                          onInputChange={handleLedgerAccountInputChange}
                          isOptionEqualToValue={(option, value) => option?.value === value?.value}
                          disabled={data.partyName.label == '' || viewMode === true ? true : false}
                          value={column?.ledgerAccount}
                          onChange={(e, newValue) => handleLedgerAccountChange(e, newValue, index)}
                          onKeyDown={(e) => handleLedgerAccountKeyDown(e, index)}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              border: 'none',
                              outline: 'none',
                              boxShadow: 'none',
                              '&:hover': {
                                border: 'none',
                                outline: 'none',
                              },
                              '&.Mui-focused': {
                                border: 'none',
                                outline: 'none',
                                boxShadow: 'none',
                              },
                              '& fieldset': {
                                border: 'none !important',
                              },
                            },

                            // Extra safety to remove outline from input itself
                            '& .MuiOutlinedInput-input': {
                              outline: 'none',
                            },

                            // Remove global focus-visible ring
                            '&:focus-visible': {
                              outline: 'none',
                              boxShadow: 'none',
                            },
                          }}
                          size="small"
                          renderOption={(props, option) => (
                            <>
                              {option === 'Add Accounts' ? (
                                <MenuItem
                                  value={'addAccount'}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const updatedTableArr = [...nonItems];
                                    setNonRowIndex(index);
                                    setUpdatedTableRow(updatedTableArr);
                                    setOpenAddAccountModal(true);
                                    setModalEvent(true);
                                  }}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    position: 'sticky',
                                    // bottom: "-7.5px",
                                    mt: '-8px !important',
                                    top: '-8px !important',
                                    zIndex: 2,
                                    backgroundColor: grey[50],
                                    '&:hover': {
                                      backgroundColor: grey[200],
                                    },
                                  }}
                                >
                                  <AddBox
                                    fontSize="small"
                                    sx={{
                                      marginRight: '5px',
                                      color: 'primary.main',
                                    }}
                                  />
                                  <ListItemText sx={{ color: 'primary.main' }} primary={'Add Accounts'} />
                                </MenuItem>
                              ) : option === 'Show All Accounts' ? (
                                <MenuItem
                                  value={'showAllAccounts'}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (displayAllAccounts === false) {
                                      setDisplayAllAccounts(true);
                                    } else {
                                      setDisplayAllAccounts(false);
                                    }
                                  }}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    position: 'sticky',
                                    bottom: '-8px',
                                    mb: '-8px',
                                    // top: "0px",
                                    zIndex: 1,
                                    ml: '-10px',
                                    backgroundColor: grey[50],
                                    '&:hover': {
                                      backgroundColor: grey[200],
                                    },
                                  }}
                                >
                                  <Checkbox
                                    checked={displayAllAccounts}
                                    fontSize="small"
                                    sx={{
                                      marginRight: '5px',
                                      color: 'primary.main',
                                    }}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      if (e.target.checked == true) {
                                        setDisplayAllAccounts(true);
                                      } else {
                                        setDisplayAllAccounts(false);
                                      }
                                    }}
                                  />
                                  <ListItemText sx={{ color: 'primary.main' }} primary={'Show All Accounts'} />
                                </MenuItem>
                              ) : (
                              <li {...props}>
  <span style={{ fontSize: "16px", lineHeight: '20px',fontWeight:'400px'}}>
    {option.label}
    {option?.groupName?.length ? (
      <span style={{ fontStyle: "italic", marginLeft: 4 }}>
        ({option.groupName.trim()})
      </span>
    ) : null}
  </span>
</li>

                              )}
                            </>
                          )}
                          renderInput={(params) => (
                            <TextField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label=""
                            />
                          )}
                        />
                      </Tooltip>
                    </TableCell>
                    {(Type === 'DebitNote' || Type === 'CreditNote') && (
                      <TableCell align="left">
                        <Tooltip title={column?.reason}>
                          <TextField
                            size="small"
                            id={'nonreason' + index}
                            name={'nonreason' + index}
                            disabled={viewMode === true ? true : false}
                            value={column?.reason}
                            onChange={(e) => handleReasonChange(e, index)}
                            onKeyDown={(e) => handleReasonKeyDown(e, index)}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                border: 'none',
                                outline: 'none',
                                boxShadow: 'none',
                                '&:hover': {
                                  border: 'none',
                                  outline: 'none',
                                },
                                '&.Mui-focused': {
                                  border: 'none',
                                  outline: 'none',
                                  boxShadow: 'none',
                                },
                                '& fieldset': {
                                  border: 'none !important',
                                },
                              },

                              // Extra safety to remove outline from input itself
                              '& .MuiOutlinedInput-input': {
                                outline: 'none',
                              },

                              // Remove global focus-visible ring
                              '&:focus-visible': {
                                outline: 'none',
                                boxShadow: 'none',
                              },
                              width: 150,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Tooltip>
                      </TableCell>
                    )}
                    {registrationType !== 1 && (
                      <>
                        {data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 && (
                          <TableCell
                            className={
                              column?.GSTRate === '' &&
                              nonItemValid === false &&
                              (data?.taxability?.value == 1 ||
                                data?.taxability?.value == 4 ||
                                data?.taxability?.value == 6 ||
                                data?.taxability?.value == 8 ||
                                data?.taxability?.value == 9 ||
                                data?.taxability?.value == 7 ||
                                data?.taxability?.value === '')
                                ? tabelCellClass?.errorTableCell
                                : ''
                            }
                          >
                            <Autocomplete
                              id={'nonGSTRate' + index}
                              name={'nonGSTRate' + index}
                              openOnFocus
                              autoFocus
                              disableClearable
                              className={classes.autocomplete}
                              disabled={
                                registrationType !== 3
                                  ? column?.ledgerAccount.value === '' ||
                                    data?.taxability?.value === 2 ||
                                    column.taxability.value === 3 ||
                                    column.taxability.value === 5 ||
                                    viewMode === true
                                    ? true
                                    : false
                                  : column.ledgerAccount.value === '' ||
                                    viewMode === true ||
                                    data?.taxability?.value === 2 ||
                                    data?.taxability?.value === 3 ||
                                    data?.taxability?.value === 5 ||
                                    (companyType == 3 && (partyType === 'CUSTOMER' || Type === 'Pos'))
                                  ? true
                                  : false
                              }
                              value={
                                (companyType == 3
                                  ? partyType === 'SUPPLIER'
                                    ? gstOrCompositeRate
                                    : compositeRate
                                  : gstOrCompositeRate
                                )?.find((item) => item.id === column?.GSTRate) || null
                              }
                              options={
                                companyType == 3 ? (partyType === 'SUPPLIER' ? gstOrCompositeRate : compositeRate) : gstOrCompositeRate
                              }
                              getOptionLabel={(option) => option.rate}
                              isOptionEqualToValue={(option, value) => option.value === value?.value}
                              onChange={(event, newValue) => handleGSTRateChange(newValue, index, 0)}
                              onKeyDown={(e) => handleGSTRateKeyDown(e, index)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="nonGSTRate"
                                  id="nonGSTRate"
                                  label=""
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                />
                              )}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  border: 'none',
                                  outline: 'none',
                                  boxShadow: 'none',
                                  '&:hover': {
                                    border: 'none',
                                    outline: 'none',
                                  },
                                  '&.Mui-focused': {
                                    border: 'none',
                                    outline: 'none',
                                    boxShadow: 'none',
                                  },
                                  '& fieldset': {
                                    border: 'none !important',
                                  },
                                },

                                // Extra safety to remove outline from input itself
                                '& .MuiOutlinedInput-input': {
                                  outline: 'none',
                                },

                                // Remove global focus-visible ring
                                '&:focus-visible': {
                                  outline: 'none',
                                  boxShadow: 'none',
                                },
                                width: 70,
                              }}
                            />
                          </TableCell>
                        )}
                        <TableCell
                          className={
                            (column?.HSN?.value === '' || column?.HSN?.value === undefined || column?.HSN.value === undefined) &&
                            // EInvoiceFlag &&
                            // Type === "Sales" &&
                            // // &&
                            // // data.partyCategory !== "UB"
                            // registrationType !== 1 &&
                            companyType === 2 &&
                            partyType === 'CUSTOMER' &&
                            nonItemValid === false
                              ? tabelCellClass?.errorTableCell
                              : ''
                          }
                        >
                          <Tooltip title={column?.HSN?.label}>
                            <Autocomplete
                              id={'nonhsnCode' + index}
                              name={'nonhsnCode' + index}
                              disableClearable
                              openOnFocus
                              options={['Add HSN/SAC Code', ...filterHSN]}
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                              componentsProps={{
                                popper: {
                                  style: {
                                    maxWidth: 300,
                                    overflow: 'auto',
                                  },
                                },
                              }}
                              noOptionsText={'Search'}
                              disabled={column?.ledgerAccount?.value == '' || viewMode === true ? true : false}
                              clearIcon={column?.HSN?.value !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                              value={column.HSN}
                              className={classes.autocomplete}
                              onChange={(e, newValue) => handleHSNCodeChange(e, newValue, index)}
                              onInputChange={(e, newValue) => handleHSNInputChange(e, newValue)}
                              onKeyDown={(e) => handleHSNKeyDown(e, index)}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  border: 'none',
                                  outline: 'none',
                                  boxShadow: 'none',
                                  '&:hover': {
                                    border: 'none',
                                    outline: 'none',
                                  },
                                  '&.Mui-focused': {
                                    border: 'none',
                                    outline: 'none',
                                    boxShadow: 'none',
                                  },
                                  '& fieldset': {
                                    border: 'none !important',
                                  },
                                },

                                // Extra safety to remove outline from input itself
                                '& .MuiOutlinedInput-input': {
                                  outline: 'none',
                                },

                                // Remove global focus-visible ring
                                '&:focus-visible': {
                                  outline: 'none',
                                  boxShadow: 'none',
                                },
                                width: 120,
                              }}
                              ListboxProps={HSNListboxProps}
                              size="small"
                              renderOption={(props, option) => (
                                <>
                                  {option === 'Add HSN/SAC Code' ? (
                                    <MenuItem
                                      value={'addHsn'}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        setHSNParamsID('');
                                        const updatedTableArr = [...nonItems];
                                        setUpdatedTableRow(updatedTableArr);
                                        setNonRowIndex(index);
                                        setOpenHsnModal(true);
                                      }}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        position: 'sticky',
                                        // bottom: "-7.5px",
                                        top: '0px',
                                        backgroundColor: grey[50],
                                        '&:hover': {
                                          backgroundColor: grey[200],
                                        },
                                      }}
                                    >
                                      <AddBox
                                        fontSize="small"
                                        sx={{
                                          marginRight: '5px',
                                          color: 'primary.main',
                                        }}
                                      />
                                      <ListItemText sx={{ color: 'primary.main' }} primary={'Add HSN/SAC Code'} />
                                    </MenuItem>
                                  ) : (
                                    <li {...props}>{option.label}</li>
                                  )}
                                </>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  placeholder="Search"
                                  onClick={() => {
                                    // setFilterHSN([]);
                                  }}
                                  {...params}
                                  label=""
                                />
                              )}
                            />
                          </Tooltip>
                        </TableCell>
                      </>
                    )}
                    <TableCell colSpan={5}>
                      <Tooltip title={column?.description}>
                        <TextField
                          value={column?.description}
                          onChange={(e) => handleDescriptionChange(e, index)}
                          disabled={column.ledgerAccount.value == '' || viewMode === true ? true : false}
                          id={'description' + index}
                          label=""
                          type="text"
                          variant="outlined"
                          size="small"
                          fullWidth
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              border: 'none',
                              outline: 'none',
                              boxShadow: 'none',
                              '&:hover': {
                                border: 'none',
                                outline: 'none',
                              },
                              '&.Mui-focused': {
                                border: 'none',
                                outline: 'none',
                                boxShadow: 'none',
                              },
                              '& fieldset': {
                                border: 'none !important',
                              },
                            },

                            // Extra safety to remove outline from input itself
                            '& .MuiOutlinedInput-input': {
                              outline: 'none',
                            },

                            // Remove global focus-visible ring
                            '&:focus-visible': {
                              outline: 'none',
                              boxShadow: 'none',
                            },
                            // minWidth: 500,
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onKeyDown={(e) => handleDescriptionKeyDown(e, index)}
                        />
                      </Tooltip>
                    </TableCell>

                    <TableCell
                      className={
                        // isFocusNonItemRow === false &&
                        (column?.taxableAMount === 0 || Number(column?.taxableAMount) === 0 || column?.taxableAMount === '') &&
                        nonItemValid === false
                          ? tabelCellClass.errorTableCell
                          : ''
                      }
                    >
                      <MoneyTextField
                        value={column?.taxableAMount?Number(column?.taxableAMount):null}
                        inputRef={textFieldRef}
                        onFocus={(e) => {
                          scrollToField();
                        }}
                        //onClick={moveCursorToEnd}
                        // onChange={(e) => handleTaxableAmountChange(e, index, column?.manualGSTFlag)}
                         onChange={(val) => handleTaxableAmountChange(val, index, column?.manualGSTFlag)}
                        // onBlur={() => handleTaxableAmountBlur(index)}
                        onKeyDown={(e) => handleTaxableAmountKeyDown(e, index)}
                        type="text"
                        min={0}
                        max={9999999999}
                        maxErrorMessage='Maximum 10 digits allowed before decimal.'
                        disabled={column.ledgerAccount.value == '' || viewMode === true ? true : false}
                        id={'nontaxableAMount' + index}
                        name={'nontaxableAMount' + index}
                        label=""
                        variant="outlined"
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            border: 'none',
                            outline: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                              border: 'none',
                              outline: 'none',
                            },
                            '&.Mui-focused': {
                              border: 'none',
                              outline: 'none',
                              boxShadow: 'none',
                            },
                            '& fieldset': {
                              border: 'none !important',
                            },
                          },

                          // Extra safety to remove outline from input itself
                          '& .MuiOutlinedInput-input': {
                            outline: 'none',
                          },

                          // Remove global focus-visible ring
                          '&:focus-visible': {
                            outline: 'none',
                            boxShadow: 'none',
                          },
                          // minWidth: 180,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          inputProps: {
                            style: {
                              textAlign: 'right',
                              paddingRight: '0px',
                            },
                            min: 0,
                          },
                        }}
                      />
                    </TableCell>
                    {registrationType !== 1 &&
                      !(registrationType === 3 && (Type === 'Sales' || Type === 'Pos' || partyType === 'CUSTOMER')) && (
                        <>
                          {data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 && (
                            // <TableCell align="right">
                            //   <div
                            //     tabIndex={0}
                            //     style={{ outline: "none", minWidth: "80px" }}
                            //     id={"nonIGST" + index}
                            //     onKeyDown={(e) => {
                            //       const cessFlag =
                            //         companyData?.relatedcompanydetailsnew?.[0]
                            //           ?.gstcompensationcessflag;
                            //       const warMsg = "";

                            //       const currentId = "nonIGST" + index;
                            //       const nextId =
                            //         cessFlag == 1 || Type !== "Sales"
                            //           ? "nongstCess" + index
                            //           : "nonnetAmount" + index;

                            //       const prevID = "nontaxableAMount" + index;

                            //       const required = false;
                            //       handleTextKeyDown(
                            //         e,

                            //         currentId,
                            //         nextId,
                            //         required,
                            //         warMsg,
                            //         prevID
                            //       );
                            //     }}
                            //   >
                            //     {Number(column?.IGST) > 0 ? (
                            //       <ToolTipComponent
                            //         title={
                            //           data.placeOfSupply.value ==
                            //           companyState ? (
                            //             // EInvoiceFlag &&
                            //             partyType === "CUSTOMER" &&
                            //             data?.partyCategory === "SEZ" ? (
                            //               <Typography
                            //                 sx={{
                            //                   fontSize: "14px",
                            //                   minWidth: 80,
                            //                 }}
                            //               >
                            //                 <span>
                            //                   IGST :
                            //                   {MoneyFormatv3(
                            //                     column.IGST,
                            //                     "en-IN"
                            //                   )}
                            //                 </span>
                            //               </Typography>
                            //             ) : (
                            //               <Typography
                            //                 sx={{
                            //                   display: "flex",
                            //                   flexDirection: "column",
                            //                   minWidth: "100px",
                            //                 }}
                            //               >
                            //                 <span>
                            //                   CGST :{" "}
                            //                   {MoneyFormatv3(
                            //                     Math.round(
                            //                       (column.IGST / 2) * 100
                            //                     ) / 100,
                            //                     "en-IN"
                            //                   )}
                            //                 </span>
                            //                 <span>
                            //                   SGST :{" "}
                            //                   {MoneyFormatv3(
                            //                     Math.round(
                            //                       (column.IGST / 2) * 100
                            //                     ) / 100,
                            //                     "en-IN"
                            //                   )}
                            //                 </span>
                            //               </Typography>
                            //             )
                            //           ) : (
                            //             <Typography
                            //               sx={{
                            //                 fontSize: "14px",
                            //                 minWidth: 80,
                            //               }}
                            //             >
                            //               <span>
                            //                 IGST :
                            //                 {MoneyFormatv3(
                            //                   column.IGST,
                            //                   "en-IN"
                            //                 )}
                            //               </span>
                            //             </Typography>
                            //           )
                            //         }
                            //         tooltipContent={MoneyFormatv3(
                            //           column.IGST,
                            //           "en-IN"
                            //         )}
                            //       />
                            //     ) : (
                            //       <Typography
                            //         sx={{
                            //           fontSize: "14px",
                            //           minWidth: 80,
                            //         }}
                            //       >
                            //         <span>{MoneyFormatv3(0, "en-IN")}</span>
                            //       </Typography>
                            //     )}
                            //   </div>
                            // </TableCell>
                            <TableCell align="right">
                              <div tabIndex={0} style={{ outline: 'none', minWidth: '80px' }} id={'nonIGST' + index}>
                                <MoneyTextField
                                  id={'nonIGST' + index}
                                  variant="standard"
                                    min={0}
                                    disabled={[2, 3, 5,7,9].includes(data?.taxability?.value)}
                                  value={column?.IGST?Number(column?.IGST):null}
                                  // onChange={(e) => {
                                  //   let newValue = e.target.value.replace(/,/g, '');

                                  
                                  //   if (newValue === '') {
                                  //     handleGSTRateChange('', index, 1);
                                  //     return;
                                  //   }

                                   
                                  //   if (!/^\d*\.?\d*$/.test(newValue)) return;
                                  //   const decimalPart = newValue.split('.')[1];
                                  //   if (decimalPart && decimalPart.length > 2) return;

                                  //   handleGSTRateChange(newValue, index, 1);
                                  // }}
                                   onChange={(newValue) => {
                                   

                                    handleGSTRateChange(newValue, index, 1);
                                  }}
                                  // onBlur={() => handleGstAmtBlur(index)}
                                  onKeyDown={(e) => {
                                    const cessFlag = isCessFlag;
                                    // companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
                                    const warMsg = '';

                                    const currentId = 'nonIGST' + index;
                                    const nextId =
                                      (cessFlag == 1 && (Type === 'Sales' || Type === 'Pos')) ||
                                      Type === 'Purchase' ||
                                      Type === 'DebitNote' ||
                                      Type === 'CreditNote'
                                        ? 'nongstCess' + index
                                        : 'nonnetAmount' + index;

                                    const prevID = 'nontaxableAMount' + index;
                                    const required = false;

                                    handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
                                  }}
                                  InputProps={{
                                    disableUnderline: true,
                                    style: { minWidth: '80px', textAlign: 'right' },
                                    readOnly: !column?.taxableAMount || partyType === 'CUSTOMER' ? true : false,
                                  }}
                                  inputProps={{
                                    style: { textAlign: 'right' },
                                  }}
                                />
                              </div>
                            </TableCell>
                          )}
                          {(Type !== 'Sales' || 
                          // companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag
                          isCessFlag
                           !== 0) &&
                            data?.taxability?.value !== 2 &&
                            data?.taxability?.value !== 3 &&
                            data?.taxability?.value !== 5 && (
                              <TableCell align="right" sx={{ minWidth: '80px' }}>
                                <MoneyTextField
                                  value={column?.GSTCess?Number(column?.GSTCess):null}
                                  // onChange={(e) => handleGSTCessChange(e, index)}
                                   onChange={(val) => handleGSTCessChange(val, index)}
                                  // onBlur={() => handleGSTCessBlur(index)}
                                  onKeyDown={(e) => handleGSTCessKeyDown(e, index)}
                                  disabled={
                                    
                                    registrationType !== 3
                                      ? column.ledgerAccount.value === '' ||
                                        data.taxability.value === 2 ||
                                        data.taxability.value === 3 ||
                                        data.taxability.value === 5 ||
                                        data.taxability.value === 7 ||  data.taxability.value === 9 ||
                                        viewMode === true || Number(column?.taxableAMount)===0
                                        ? true
                                        : false
                                      : column.ledgerAccount.value === '' ||
                                        data.taxability.value === 2 ||
                                        data.taxability.value === 3 ||
                                        data.taxability.value === 5 ||
                                        data.taxability.value === 7 || data.taxability.value === 9 ||
                                        viewMode === true || Number(column?.taxableAMount)===0
                                      ? true
                                      : false
                                  }
                                    min={0}
                                    max={10000000000}
                                  id={'nongstCess' + index}
                                  name={'nongstCess' + index}
                                  label=""
                                  type="text"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      border: 'none',
                                      outline: 'none',
                                      boxShadow: 'none',
                                      '&:hover': {
                                        border: 'none',
                                        outline: 'none',
                                      },
                                      '&.Mui-focused': {
                                        border: 'none',
                                        outline: 'none',
                                        boxShadow: 'none',
                                      },
                                      '& fieldset': {
                                        border: 'none !important',
                                      },
                                    },

                                    // Extra safety to remove outline from input itself
                                    '& .MuiOutlinedInput-input': {
                                      outline: 'none',
                                    },

                                    // Remove global focus-visible ring
                                    '&:focus-visible': {
                                      outline: 'none',
                                      boxShadow: 'none',
                                    },
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  InputProps={{
                                    inputProps: {
                                      style: {
                                        textAlign: 'right',
                                        paddingRight: '0px',
                                      },
                                      min: 0,
                                    },
                                  }}
                                />
                              </TableCell>
                            )}
                          <TableCell align="right">
                            <Typography
                              tabIndex="0"
                              id={'nonnetAmount' + index}
                              onKeyDown={(e) => {
                                const cessFlag = isCessFlag;
                                // companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
                                if (e.key === 'Tab' && e.shiftKey) {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const element =
                                    registrationType == 1
                                      ? 'description' + index
                                      : cessFlag == 1
                                      ? 'nongstCess' + index
                                      : 'nonIGST' + index;
                                  document.getElementById(element)?.focus();
                                  return;
                                }
                                if ((e.key === 'Tab' && !e.shiftKey) || e.key === 'Enter') {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  saveChangesInNonRows(index);
                                }
                              }}
                              sx={{
                                fontSize: '14px',
                                outline: 'none',
                              }}
                            >
                              {MoneyFormatv3(Number(column.netAmount).toFixed(2), 'en-IN')}
                            </Typography>
                          </TableCell>
                        </>
                      )}

                    <TableCell
                      align="right"
                      sx={{
                        backgroundColor: '#FFF',
                        position: 'sticky',
                        right: 0,
                        zIndex: 1,
                      }}
                      // className="actionBackGround"
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <IconButton
                          disabled={viewMode === true ? true : false}
                          disableRipple
                          aria-label="delete"
                          sx={{
                            margin: '0px 2px',
                            padding: '5px',
                            backgroundColor: '#fbc7c78c',
                          }}
                          onClick={() => {
                            if (column?.ledgerAccount?.label === '') {
                              noncloseChangesInRows(index);
                            } else {
                              setNonRowIndex(index);
                              setDeleteNonEntriesModal(true);
                            }
                          }}
                        >
                          <CloseIcon
                            sx={{
                              fontSize: '18px',
                              color: '#eb6a6a',
                            }}
                          />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow sx={{ height: '40px' }} className={tabelCellClass.table}>
                <TableCell
                  align="center"
                  colSpan={
                    registrationType === 3
                      ? Type === 'Sales' || Type === 'Pos'
                        ? 13 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                        : partyType === 'CUSTOMER'
                        ? 14 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                        : Type === 'Purchase'
                        ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                        : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : registrationType !== 1
                      ? 
                      // companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag
                      isCessFlag
                       === 1
                        ? Type === 'Sales' || Type === 'Purchase'
                          ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                          : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                        : Type === 'Sales'
                        ? 15 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
                        : Type === 'Purchase'
                        ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                        : 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                      : Type === 'Sales' || Type === 'Purchase'
                      ? 11
                      : 12
                    // - (partyType === "CUSTOMER" ? 0 : 1)
                  }
                >
                  No Items Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableRow
            className={tabelCellClass.table}
            sx={{
              dispaly: 'flex',
              justifyContent: 'space-between',
              maxHeight: '40px',
              width: '100%',
            }}
          >
            {viewMode !== true && (
              <TableCell
                colSpan={
                  registrationType === 3
                    ? Type === 'Sales' || Type === 'Pos'
                      ? 14 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : partyType === 'CUSTOMER'
                      ? 15 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : Type === 'Purchase'
                      ? 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                      : 18 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 1)
                    : registrationType !== 1
                     ? 
                    //  companyData?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag
                     isCessFlag=== 1
                      ? Type === 'Sales' || Type === 'Purchase'
                        ? 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                        : 18 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                      : Type === 'Sales'
                      ? 16 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 2)
                      : Type === 'Purchase'
                      ? 17 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                      : 18 - (data?.taxability?.value !== 2 && data?.taxability?.value !== 3 && data?.taxability?.value !== 5 ? 0 : 3)
                    : Type === 'Sales' || Type === 'Purchase'
                    ? 11
                    : 12
                  // - (partyType === "CUSTOMER" ? 0 : 1)
                }
              >
                <Button
                  disableElevation
                  className={viewMode == true ? 'disable-interactions' : ''}
                  disableRipple
                  size="small"
                  variant="text"
                  startIcon={<AddBox />}
                  sx={{
                    fontSize: '14px',
                  }}
                  onClick={() => {
                    saveChangesInNonRows('');
                  }}
                >
                  Add New Line
                </Button>
              </TableCell>
            )}
          </TableRow>
        </>
      )}
      {modalEvent === true && (
        <AddAccountModal
          open={openAddAccountModal}
          setOpen={setOpenAddAccountModal}
          setData={setNonItems}
          data={updatetedTableRow[nonRowIndex]}
          showSuccessSnackbar={showSuccessSnackbar}
          showWarningSnackbar={showWarningSnackbar}
          showErrorSnackbar={showErrorSnackbar}
          accountType={'ledgerAccount'}
          setAllAccount={setAccNames}
          Type={Type}
          setNonItemEditedRow={setNonItems}
          setNewPartyID={setNewPartyID}
          setSelectedGroupId={setSelectedGroupId}
          selelctedGroupId={selelctedGroupId}
          newPartyID={newPartyID}
          setNewPartyName={setNewPartyName}
          newPartyName={newPartyName}
          rowIndex={nonRowIndex}
          updatetedTableRow={updatetedTableRow}
          partyType={partyType}
          getAccountGSTDetails={getAccountGSTDetails}
        />
      )}
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          showWarningSnackbar={showWarningSnackbar}
          showSuccessSnackbar={showSuccessSnackbar}
          showErrorSnackbar={showErrorSnackbar}
          setData={setNonItems}
          searchHSNSAC={() => searchHSNDetails('', 0, 20)}
          hsnParamsID={hsnParamsID}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          data={updatetedTableRow[nonRowIndex]}
          rowIndex={nonRowIndex}
          updatetedTableRow={updatetedTableRow}
          itemType={'ledger'}
          page="Invoice"
        />
      )}
    </>
  );
}

export default NewNonItemTable;
